import { z } from 'zod';
export const UpdateDocumentSchema = z.object({
    name: z.string().min(1).optional().nullable(),
    source: z.string().min(1).optional().nullable()
});
//# sourceMappingURL=updateDocumentSchema.js.map